const messages = {
    buttons: {
        productBrochures: "Descubrir",
    },
    index: {
        title: "INFORMACIÓN DEL PRODUCTO",
        description: "Descargue aquí los últimos folletos y volantes de nuestros neumáticos Bridgestone y Firestone.",
        categories: {
            productBrochures: {
                title: "Folletos de productos",
                description: "Folletos de las gamas de neumáticos Bridgestone y Firestone",
            },
            bDrive: {
              title: "Imágenes de productos",
              description: "Encontrará imágenes actualizadas para descargar en nuestro portal B-DRIVE.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

